export function OPENROUTER_KEY(): string {
    return localStorage.openrouter_key || ''
}
